// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { compareAsc as fn } from "../compareAsc.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const compareAsc = convertToFP(fn, 2);

// Fallback for modularized imports:
export default compareAsc;
